import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { EventEmitterBo } from './timesheet.modal';

@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.scss']
})
export class TimesheetComponent implements OnInit {
  TimesheetEditList: boolean = false;

  constructor(public global: GlobalComponent) {
    this.global.checkforlogout();
  }
  
  ngOnInit(): void {

  }

  isListorUpdateView: EventEmitterBo = {
    isCreate: false, TimesheetId: "00000000-0000-0000-0000-000000000000",
    ClientList: null
  };

  EmitChildComponent(event: EventEmitterBo) {
    this.TimesheetEditList = event.isCreate;
    this.isListorUpdateView = event;
  }
}

